/* eslint-disable react-refresh/only-export-components */
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  useRouteError
} from 'react-router';

import { BaseLayout } from '@link/china-railway/layouts';
import ChinaRailway from '@link/china-railway/views/ChinaRailway';
import OrderDetail from '@link/china-railway/views/OrderDetail';
import TrainList from '@link/china-railway/views/TrainList';

import { lazy, Suspense } from 'react';

const NotFound = lazy(() => import('@link/china-railway/views/NotFound'));

function RootErrorBoundary() {
  const error = useRouteError() as Error;
  if (error.message.includes('Failed to fetch dynamically imported module')) {
    location.reload();
  }
  return null;
}

const lazyView = (view: JSX.Element) => {
  return <Suspense fallback="Loading...">{view}</Suspense>;
};

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route errorElement={<RootErrorBoundary />}>
      <Route>
        <Route path="/" element={<BaseLayout />}>
          <Route path="/railway/:bookingId/:token" element={<ChinaRailway />} />
          <Route path="/train-list/:date" element={<TrainList />} />
          <Route
            path="/order-detail/:bookingId/:token"
            element={<OrderDetail />}
          />
          <Route index element={<NotFound />} />
        </Route>
      </Route>
      <Route path="*" element={lazyView(<NotFound />)} />
    </Route>
  )
);

export default router;
